import { createFileRoute } from '@tanstack/react-router'
import { ActivityLog } from '@/components/operations/ActivityLog'

export const Route = createFileRoute('/_auth/operations/activity')({
  component: ActivityLog,
})
